import { Box, type PlacementWithLogical, Tooltip, type TooltipProps } from '@chakra-ui/react'
import { appColors } from '@theme/foundations/colors'
import { useState } from 'react'
import { Info } from 'react-feather'
import { InfoIcon } from '../assets/icons'

export const tooltipDefaultProps = {
  bg: 'white',
  color: 'gray.800',
  fontWeight: 'normal',
  borderRadius: 'base',
  hasArrow: true,
} as const satisfies Partial<TooltipProps>

export const cellTooltipProps = {
  ...tooltipDefaultProps,
  p: '2',
  placement: 'top',
} as const satisfies Partial<TooltipProps>

export interface BaseTooltipProps {
  label?: string | React.ReactNode
  width?: string | number
  height?: string | number
  color?: string
  blackIcon?: boolean
  placement?: PlacementWithLogical
  icon?: React.ReactNode
}

export const BaseTooltip = ({ label, width = '24px', height = '24px', color, blackIcon, placement, icon }: BaseTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(oldState => !oldState)
  }

  const handleMouseEnter = () => {
    setIsOpen(() => true)
  }

  const handleMouseLeave = () => {
    setIsOpen(() => false)
  }

  const props = {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    width,
    height,
    color: color ?? appColors.accentPrimary,
  }

  return (
    <Tooltip {...tooltipDefaultProps} placement={placement} isOpen={isOpen} label={label} p='4' minWidth={props.width}>
      {blackIcon ? (
        <Box display='flex' alignItems='center' justifyContent='center' {...props}>
          <InfoIcon color='#0D0D0D' width={props.width} height={props.height} />
        </Box>
      ) : icon ? (
        <div {...props}>{icon}</div>
      ) : (
        <Info {...props} />
      )}
    </Tooltip>
  )
}
